<template>
    <div>
        <invoice-info :order_id="table_ids" :amount="amount" :source="source" v-if="show_info"></invoice-info>
        <invoice-affirm :order_id="order_id" :appInvoiceInfo="invoiceInfo" :orderInfo="orderInfo" :isShowContact="isShowContact"  v-if="show_affirm"></invoice-affirm>
        <invoice-succeed v-if="show_succeed"></invoice-succeed>
        <invoice-list :orderInfo="orderInfo" :invoiceInfo="invoiceInfo" v-if="show_list"></invoice-list>
        <invoice-invalid :order_id="order_id" :invoiceInfoList="invoiceInfoList" v-if="show_invalid"></invoice-invalid>
    </div>
    
</template>
<script>
import InvoiceInfo from '@/pages/common/invoiceAppInfo.vue'
import InvoiceAffirm from '@/pages/common/invoiceAppAffirm.vue'
import InvoiceSucceed from '@/pages/common/invoiceAppSucceed.vue'
import InvoiceList from '@/pages/common/invoiceList.vue'
import invoiceInvalid from '@/pages/common/invoiceInvalid.vue'
import { debug } from 'util';
export default {
    name: 'Invoice',
    componentName: 'Invoice',
    components: {
        InvoiceInfo,
        InvoiceAffirm,
        InvoiceSucceed,
        InvoiceList,
        invoiceInvalid
    },
    data() {
        return {
            show_info: true,
            show_affirm: '',
            show_succeed: '',
            show_list: '',
            show_invalid:'',
            order_id:'',
            amount:'',
            listInfo:'',
            isShowContact: false,
            table_ids:[],
            source:'',
            closeDialog:'',
            invoiceInfoList:[],
            isShowInfo: this.isInvoiced
        }
    },
    props: {
      appInvoiceInfo:{
      },
      isInvoiced:{
          type: Boolean,
      },
      orderInfo:{
      },
      invoiceInfo:{
      },
      appInvoice:{
      }
      },
    created() {
        this.$on('cut.invoice', this.cut)
        if(this.isShowInfo == true) {
            this.show_list = this.isShowInfo
            this.show_info = false;
        } else {
            this.getAppInvoice()
        }
    },
    methods: {
        cut(params) {
            this.show_info = params.show_info
            this.show_affirm = params.show_affirm
            this.show_succeed = params.show_succeed
            this.closeDialog = params.closeDialog  //dialog关闭事件
            this.show_invalid = params.show_invalid
            this.show_list = params.show_list
            this.amount = params.amount  //订单未开票金额
            this.order_id = params.order_id
            this.table_ids = params.order_id 
            this.isShowContact = params.isShowContact //控制是否显示联系人和联系人电话
            this.invoiceInfoList = params.invoiceList
            this.isShowInfo = params.isShowInfo
            if(this.closeDialog == true) {
                this.$emit('closeDialog')
            }
        },
        getAppInvoice() {
            let sum = 0
            this.orderInfo.forEach(element => {
                this.source = element.order_info.source
                this.table_ids.push(element.order_info_id+ '@' + this.source)
                sum = sum + parseFloat(element.uninvoice_amount)
            });
            this.amount = sum + ''
            this.table_ids = this.table_ids.join(",")
        }
    }
    
}
</script>



// WEBPACK FOOTER //
// src/pages/common/invoice.vue